import React, { useEffect, useState, useContext } from "react";
import { Button, Dropdown } from "react-bootstrap";
import { TagsFill } from "react-bootstrap-icons";
import "../options/Categorization.scss";
import { SketchPicker } from 'react-color';
import { SESSION_ACTIONS } from "./state/SessionReducer";
import { SessionContext } from "./state/SessionContext";
import { sendCommand, postCommand } from "../components/Bridge";

function SessionCategorization() {

    const { sessionState, dispatchSessionState } = useContext(SessionContext);
    const [modified, setModified] = useState(false);
    const [categories, setCategories] = useState({ levelColors: [], names: [] });

    const categoryNameChanged = (index, name) => {
        //console.log(index, name);
        let copy = JSON.parse(JSON.stringify(sessionState.categories));
        copy.names[index] = name;
        setCategories(copy);
        setModified(true);
    }
    const categoryColorChanged = (index, color, event) => {
        console.log(index, color);
        let copy = JSON.parse(JSON.stringify(sessionState.categories));
        copy.levelColors[index].red = color.rgb.r;
        copy.levelColors[index].green = color.rgb.g;
        copy.levelColors[index].blue = color.rgb.b;
        copy.levelColors[index].alpha = color.rgb.a;
        setCategories(copy);
        setModified(true);
    }

    const cancel = () => {
        sendCommand("session/categories").then((response)=>{
            let colorsConfiguration = response.data;
            setCategories(colorsConfiguration);
            setModified(false);
        }).catch(err=>{});
    }

    const save = () => {
        categories.levelColors.forEach((level) => {
            delete (level.rgb);
            delete (level.transparency);
            delete (level.colorSpace);
        });
        postCommand("session/categories", categories).then((response)=>{
            setModified(false);
            dispatchSessionState({
                type: SESSION_ACTIONS.CATEGORIES_UPDATED,
                payload: categories
            });
        }).catch(err=>{});

    }

    useEffect(() => {
        setCategories(sessionState.categories);
    }, [sessionState.categories]);

    return (
        categories !== null ?
            <div className="options-categorization">
                <div className="header">Session categorization</div>
                <div className="description">Choisissez les noms et couleurs des catégories de session</div>
                {categories.levelColors.map((level, index) =>
                    index < 10 ?
                        <div className="row" key={"category" + index} onClick={() => { }}>
                            <Dropdown className="session-categories" >
                                <Dropdown.Toggle variant="success">
                                    <TagsFill size="24" style={{ color: "rgba(" + level.red + "," + level.green + "," + level.blue + "," + level.alpha + ")" }}></TagsFill>
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                    <SketchPicker className="color" color={"rgba(" + level.red + "," + level.green + "," + level.blue + "," + level.alpha + ")"} onChange={(color, evt) => categoryColorChanged(index, color, evt)}></SketchPicker>
                                </Dropdown.Menu>
                                <input type="text" value={categories.names[index]} onChange={(evt) => categoryNameChanged(index, evt.target.value)} />
                            </Dropdown>
                        </div> : <></>
                )
                }
                <div className="actions"><Button className="cancel" disabled={!modified} onClick={cancel}>Cancel</Button><Button className="save" disabled={!modified} onClick={save}>Save</Button></div>
            </div>
            : <></>);
}
export default SessionCategorization;